import * as yup from "yup";
import { isValidCNPJ } from "../../utils/validators";
export var complaintSchema = yup.object({
    irregularityType: yup.string().required("Campo obrigatório"),
    companyName: yup.string().required("Campo obrigatório"),
    cnpj: yup
        .string()
        .optional()
        .test("cnpj", "CNPJ inválido", function (v) { return !v || isValidCNPJ(v); }),
    cep: yup.string().optional(),
    location: yup.string().required("Campo obrigatório"),
    complement: yup.string().optional(),
    description: yup
        .string()
        .required("Campo obrigatório")
        .min(20, "Mínimo de 20 caracteres"),
    files: yup.mixed().optional(),
});
